import React from 'react';
import cn from 'classnames';

const Skeleton = ({ className = '', height, width, border, style }) => {
  const outerStyles = {
    width: width ?? '100%',
    height: height ?? 50,
    borderRadius: border,
    ...style,
  };

  return (
    <div className={cn('skeleton-outer', {}, [className])} style={outerStyles}>
      <div className={'skeleton-inner'} />
    </div>
  );
};

export default Skeleton;
